var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 29.75L6.5875 24.3667C4.79919 21.8281 3.99878 18.7241 4.33648 15.6373C4.67418 12.5505 6.12678 9.69305 8.42167 7.60117C10.7166 5.50929 13.696 4.32682 16.8008 4.27566C19.9056 4.2245 22.9224 5.30816 25.2849 7.32329C27.6475 9.33842 29.1934 12.1465 29.6327 15.2205C30.0719 18.2945 29.3742 21.4231 27.6705 24.0193C25.9668 26.6154 23.3742 28.5005 20.3793 29.3209C17.3844 30.1413 14.1931 29.8405 11.4042 28.475L4.25 29.75",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 14.1667C12.75 14.3545 12.8246 14.5347 12.9575 14.6676C13.0903 14.8004 13.2705 14.875 13.4583 14.875C13.6462 14.875 13.8264 14.8004 13.9592 14.6676C14.092 14.5347 14.1667 14.3545 14.1667 14.1667V12.75C14.1667 12.5622 14.092 12.382 13.9592 12.2492C13.8264 12.1163 13.6462 12.0417 13.4583 12.0417C13.2705 12.0417 13.0903 12.1163 12.9575 12.2492C12.8246 12.382 12.75 12.5622 12.75 12.75V14.1667ZM12.75 14.1667C12.75 16.0453 13.4963 17.847 14.8247 19.1754C16.153 20.5037 17.9547 21.25 19.8333 21.25H21.25C21.4379 21.25 21.618 21.1754 21.7509 21.0426C21.8837 20.9097 21.9583 20.7295 21.9583 20.5417C21.9583 20.3538 21.8837 20.1737 21.7509 20.0408C21.618 19.908 21.4379 19.8334 21.25 19.8334H19.8333C19.6455 19.8334 19.4653 19.908 19.3325 20.0408C19.1996 20.1737 19.125 20.3538 19.125 20.5417C19.125 20.7295 19.1996 20.9097 19.3325 21.0426C19.4653 21.1754 19.6455 21.25 19.8333 21.25",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.23f8e902ddeea415dead95038d20f062.svg";
export { ForwardRef as ReactComponent };